/**
 * @flow
 */

import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import {
    filterBySalons,
    filterByMasters,
    filterByManufacturers,
} from '../../../actions/report';
import { map, reduce, filter, includes, uniqBy, property } from 'lodash';

import ReportMenu from '../components/ReportMenu';

import type { Dispatch } from '../../../type';

const mapStateToProps = ({ report }) => ({
    masterFilter: report.get('searchQuery'),
    salonFilter: report.get('salonFilter'),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    onMasterSelect: (e, { value }) => {
        dispatch(filterByMasters(value));
    },
    onSalonSelect: (e, { value }) => {
        dispatch(filterBySalons(value));
    },
    onManufacturerSelect: (e, { value }) => {
        dispatch(filterByManufacturers(value));
    },
});

function ReportMenuContainer(props) {
    const { salons, salonFilter, manufacturers } = props;

    const salonOptions = useMemo(
        () =>
            uniqBy(
                map(salons, ({ id, name, address }) => ({
                    text: name,
                    value: id,
                    description: address,
                })),
                'value',
            ),
        [salons],
    );

    const manufacturerOptions = useMemo(
        () =>
            map(
                salonFilter.length
                    ? filter(manufacturers, ({ salon }) =>
                          includes(salonFilter, salon),
                      )
                    : manufacturers,
                ({ name, salonName, id }) => ({
                    text: name,
                    value: id,
                    description: salonName,
                }),
            ),
        [manufacturers, salonFilter],
    );

    const masterOptions = useMemo(
        () =>
            reduce(
                salonFilter.length
                    ? filter(salons, ({ id }) => includes(salonFilter, id))
                    : salons,
                (result, { name, masters: { nodes }, administrators }) =>
                    uniqBy(
                        [
                            ...result,
                            ...map(
                                [...nodes, ...administrators],
                                ({ id, firstName, lastName }) => ({
                                    text: `${firstName} ${lastName}`,
                                    value: id,
                                    'data-salon': name,
                                }),
                            ),
                        ],
                        property('value'),
                    ),
                [],
            ),
        [salons, salonFilter],
    );

    return (
        <ReportMenu
            {...props}
            salonOptions={salonOptions}
            manufacturerOptions={manufacturerOptions}
            masterOptions={masterOptions}
        />
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ReportMenuContainer);
